<template>
  <div class="upload-image-action-sheet">
    <van-action-sheet v-model="isVisible" title="请选择">
      <div class="content">
        <div class="content-item" @click="selectOption('camera')">拍照</div>
        <div class="content-item" @click="selectOption('album')">
          从手机相册选择
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  export default {
    name: 'UploadImageActionSheet',
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isVisible: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$emit('input', newValue)
        }
      }
    },
    methods: {
      updateValue(value) {
        this.$emit('input', value)
      },

      // 选择上传方式
      selectOption(type) {
        this.$emit('select', type)
        this.updateValue(false)
      },

      // 关闭弹窗
      close() {
        this.updateValue(false)
      }
    }
  }
</script>

<style lang="less" scoped>
  .upload-image-action-sheet {
    .van-action-sheet__header {
      line-height: 60/20rem;
    }
    /* 组件样式 */
    .content {
      border-top: 1px solid #e4e4e4;
      margin: 0 16/20rem;
      padding-bottom: 40/20rem;
      .content-item {
        height: 56/20rem;
        line-height: 56/20rem;
        text-align: center;
        border-bottom: 1px solid #e4e4e4;
        font-family: PingFang SC;
        font-style: Regular;
        font-size: 14px;
      }
    }
  }
</style>
